import DialogComponent from 'components/Dialog';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {DialogTypes} from 'common/names';
import FormikNumberField from 'components/inputs/FormikNumberField';
import LastUpdatedLabel from 'components/LastUpdatedLabel';
import {ISessionData, SessionData} from 'types/SessionData';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {useGetApi} from 'common/hooks/useGetApi';
import api from 'api';
import {usePostApi} from 'common/hooks/usePostApi';
import Loader from 'components/Loader';
import Typography from '@mui/material/Typography';
import Panel from 'components/Panel';
import Formik from 'components/hook-form/Formik';

type SessionDataDialogProps = {
   onClose: () => void;
};

const SessionDataDialog = ({onClose}: SessionDataDialogProps) => {
   const {t} = useTranslation();
   const {request: fetchSessionData, state: session, loading} = useGetApi<ISessionData>(
      api.sessionData
   );
   const {request: saveSessionData} = usePostApi(api.sessionData, {
      onSuccess: onClose,
   });

   useEffect(() => {
      fetchSessionData();
   }, [fetchSessionData]);

   const saveSettings = (values: ISessionData) => {
      saveSessionData(JSON.stringify(values));
   };

   return (
      <DialogComponent
         maxWidth="sm"
         header={DialogTypes.SessionDataDialog.dialogName}
         close={onClose}
      >
         {loading || !session ? (
            <Loader />
         ) : (
            <Formik
               initialValues={SessionData.cast(session) as ISessionData}
               validationSchema={SessionData}
               onSubmit={saveSettings}
               enableReinitialize
            >
               <>
                  <Panel>
                     <Typography gutterBottom>
                        {t(
                           'Diplomat MFT Client sessions can be terminated after a period of inactivity.'
                        )}
                     </Typography>
                     <FormikNumberField
                        autoFocus
                        style={{textAlign: 'right', width: '190px'}}
                        name="sessionTimeout"
                        placeholder={t('Session expiration')}
                        InputProps={{endAdornment: t('Minutes')}}
                        helperText={t('Enter zero for no expiration.')}
                        min={0}
                     />
                     <LastUpdatedLabel date={session.timestamp} author={session.lastUser} />
                  </Panel>
                  <FormFooterButtons submitLabel={t('Save')} cancel={onClose} />
               </>
            </Formik>
         )}
      </DialogComponent>
   );
};

export default SessionDataDialog;
